import { forEach, uniq, cloneDeep } from 'lodash';
import moment from 'moment';
import { setSearchTerm } from '../../reducers/Sentiment';
import { dispatch, getState } from '../../config/store';
import {
  resetAllSearchParams,
  resetResultsPage,
  setOpenTopicSearchDialog,
  setTopicSearchDateRange,
  setCurrentSearchtDetail,
  setSelectedSearch,
  setAllSearchParams,
} from 'reducers/Topic';
import { performTopicSearchAggregate, performTopicTweetsSearchAggregate } from './topicActions';
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export function getSearchCombinations(suggestions) {
  const quotedCombinations = suggestions.map(c => `"${c}"`);
  return quotedCombinations.join(' OR ');
}

export function getSelectedSuggestionAsArr(suggestionsObjOrignal, searchText) {
  const suggestionsArr = [];
  let suggestionsSingleArr = [];
  let onlySuggestionSingleArr = [];
  const suggestionsObj = cloneDeep(suggestionsObjOrignal);
  const cleanSearchText = searchText.replace(/[^a-zA-Z ]/g, '');

  forEach(suggestionsObj, values => {
    if (values.length) {
      suggestionsArr.push(uniq([...values]));
      suggestionsSingleArr = [...suggestionsSingleArr, ...values];
    }
  });
  onlySuggestionSingleArr = [...suggestionsSingleArr];
  suggestionsSingleArr.unshift(cleanSearchText);
  return { suggestionsArr, suggestionsSingleArr, onlySuggestionSingleArr };
}

export const extractResultTitleFromPath = completeData => {
  let matches = completeData.match(/<span path="(.*)"><\/span>/gm) || [];
  let afterFirstSpan = completeData.match(/<heading\b[^>]*>(.*?)<\/heading>/gm) || [];

  let completeHeading = [];
  if (matches.length) {
    const spanData = matches[0];
    let pathDataArr = spanData.split('"');
    let pathData = pathDataArr[1];
    const decodedHeadingDataArr = decodeBase64URIString(pathData);
    let splitdecodedHeadingDataArr = decodedHeadingDataArr.split('|');
    if (splitdecodedHeadingDataArr.length > 2) {
      splitdecodedHeadingDataArr = splitdecodedHeadingDataArr.slice(-2);
      if (splitdecodedHeadingDataArr[1] === 'data') {
        splitdecodedHeadingDataArr.splice(1, 1);
      }
      completeHeading = splitdecodedHeadingDataArr;
    }
  }
  completeHeading = completeHeading.slice(0, completeHeading.length - 1);
  completeHeading.push(...afterFirstSpan);
  return completeHeading;
};

/* this function decode base-64 encoded string to normal String. 
   this also handle 'apostrophe' */
export const decodeBase64URIString = encodedString => {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(encodedString), c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
};

export const removeDuplicateSuggestions = suggestionsObj => {
  let suggestionsArr = [];
  const cleanSuggestionsObj = {};
  forEach(suggestionsObj, (values, keyWord) => {
    const uniqValues = uniq(values);
    uniqValues.forEach(value => {
      if (!suggestionsArr.includes(value)) {
        if (!cleanSuggestionsObj[keyWord]) {
          cleanSuggestionsObj[keyWord] = [];
        }
        cleanSuggestionsObj[keyWord].push(value);
        suggestionsArr.push(value);
      }
    });
  });
  return cleanSuggestionsObj;
};

export const renameDocumentTypes = type => {
  if (Array.isArray(type)) {
    let selected = type.map(v => {
      if (v.toLowerCase() === 'fmp-transcript' || v.toLowerCase() === 'ec-fmp') {
        v = 'Earnings Call';
      } else if (v.toLowerCase() === 'fin supp') {
        v = 'FS';
      } else if (v.toLowerCase() === 'other financials') {
        v = 'OF';
      }
      return v;
    });

    if (selected.length > 5) {
      selected = selected.slice(0, 5);
    }
    return selected.join(', ');
  }
  if (type) {
    if (type.toLowerCase() === 'fmp-transcript') {
      type = 'Earnings Call';
    } else if (type.toLowerCase() === 'fin supp') {
      type = 'FS';
    } else if (type.toLowerCase() === 'other financials') {
      type = 'OF';
    }
  } else {
    type = '';
  }

  return type;
};

export const deleteSearchSuggestionsByKey = (suggestions, deleteKeys, deleteValues) => {
  let searchValues = [];
  if (Array.isArray(deleteValues)) {
    searchValues = deleteValues;
  } else {
    searchValues = deleteValues.split(' ');
  }
  let valuesWiths = searchValues.map(v => `${v}s`);
  let values = searchValues.concat(valuesWiths);
  deleteKeys.forEach(v => {
    delete suggestions[v];
  });

  values.forEach(val => {
    forEach(suggestions, (v, k) => {
      let filterValues = v.filter(function(item) {
        return item.toLowerCase() !== val.toLowerCase();
      });
      suggestions[k] = filterValues.length > 0 ? filterValues : [];
    });
  });

  return suggestions;
};

export const getSearchText = (
  simpleSearchTextArray,
  ignoreSearchTextArray,
  searchTextWithAnd,
  onlySuggestionSingleArr,
  searchText,
  isSimpleSearch
) => {
  const value1 = simpleSearchTextArray.map(value => `"${value}"`).join(' OR ');
  const value2 = searchTextWithAnd.map(value => `"${value}"`).join(' AND ');
  const value3 = ignoreSearchTextArray.map(value => `-"${value}"`).join(' AND ');

  const searchTerm = `${value1.length > 0 ? `(${value1})` : ''}${
    value2.length > 0 && value1.length > 0 ? `AND(${value2})` : value2.length > 0 ? `(${value2})` : ''
  }${(value1.length > 0 || value2.length) && value3 ? `AND(${value3})` : value3.length > 0 ? `(${value3})` : ''}`;

  const fullSearchText = onlySuggestionSingleArr.length
    ? `(${searchText}) AND (${getSearchCombinations(onlySuggestionSingleArr)})`
    : searchText;

  return isSimpleSearch ? searchTerm : fullSearchText;
};

export const getSearchTerm = () => {
  const {
    searchText,
    selectedSuggestions,
    isSimpleSearch,
    simpleSearchTextArray,
    ignoreSearchTextArray,
    searchTextWithAnd,
  } = getState().Topic;
  const { onlySuggestionSingleArr } = getSelectedSuggestionAsArr(selectedSuggestions, searchText);
  const term = getSearchText(
    simpleSearchTextArray,
    ignoreSearchTextArray,
    searchTextWithAnd,
    onlySuggestionSingleArr,
    searchText,
    isSimpleSearch
  );
  dispatch(setSearchTerm(term));
};

export const preventParentClick = e => {
  if (e) {
    e.stopPropagation();
  }
};

export const getCurrentSearchDispaly = (
  simpleSearchTextArray,
  ignoreSearchTextArray,
  searchTextWithAnd,
  onlySuggestionSingleArr,
  searchText,
  isSimpleSearch
) => {
  const value1 = simpleSearchTextArray.filter(value => `${value},`);
  const value = ignoreSearchTextArray.filter(value => `${value},`);
  const value2 = searchTextWithAnd.filter(value => `${value},`);
  const searchTerm = `${value1}${value}${value2}`;
  const fullSearchText = onlySuggestionSingleArr.length
    ? `${searchText} OR ${getSearchCombinations(onlySuggestionSingleArr)}`
    : searchText;

  return isSimpleSearch ? searchTerm : fullSearchText;
};

export const getDocTypes = (selectedDocType, documentTypes) => {
  let docType = [];
  selectedDocType.forEach(e => {
    let doc = documentTypes.find(v => v.documentTypeGroup === e);
    if (doc) {
      docType.push(doc.value.map(e => e.value));
    }
  });
  return docType.flat();
};

export const getHumanReadableDateDuration = (startDate, endDate) => {
  moment.updateLocale('en', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: '%d seconds',
      m: '1 minute',
      mm: '%d minutes',
      h: '1 hour',
      hh: '%d hours',
      d: '1 day',
      dd: '%d days',
      M: '1 month',
      MM: '%d months',
      y: '1 year',
      yy: '%d years',
    },
  });
  const endDateLocal = moment(endDate);
  const startDateLocal = moment(startDate);
  const duration = moment.duration(endDateLocal.diff(startDateLocal));
  return duration.asHours() > 0 ? `(~${duration.humanize()})` : '';
};

export const composeNewSearch = e => {
  preventParentClick(e);
  resetThemeXSearch();
};

export const setSearchParams = searchObj => {
  searchObj = cloneDeep(searchObj);

  dispatch(setSelectedSearch(searchObj));
  dispatch(setAllSearchParams(searchObj));
  dispatch(resetResultsPage());
  setTimeout(() => {
    dispatch(performTopicSearchAggregate());
    dispatch(performTopicTweetsSearchAggregate());
  }, 500);
};

export const resetThemeXSearch = () => {
  dispatch(setOpenTopicSearchDialog(true));
  dispatch(resetAllSearchParams());
  dispatch(setSelectedSearch(null));
  dispatch(setCurrentSearchtDetail({}));
  dispatch(resetResultsPage());
};

export const setDateRangeToOneYear = () => {
  dispatch(
    setTopicSearchDateRange({
      startDate: moment()
        .startOf('month')
        .subtract(12, 'months'),
      endDate: moment().endOf('month'),
    })
  );
};

export const formAndSetCurrentSearchtDetail = () => {
  const {
    simpleSearchTextArray,
    ignoreSearchTextArray,
    searchTextWithAnd,
    isSimpleSearch,
    searchText,
    selectedSuggestions,
    searchLabel,
    startDate,
    endDate,
    selectedDocumentTypes,
  } = getState().Topic;
  const currentSearchDetail = {};

  const { onlySuggestionSingleArr } = getSelectedSuggestionAsArr(getState().Topic.selectedSuggestions, searchText);
  currentSearchDetail.searchTerm = getCurrentSearchDispaly(
    simpleSearchTextArray,
    ignoreSearchTextArray,
    searchTextWithAnd,
    onlySuggestionSingleArr,
    searchText,
    isSimpleSearch
  );
  currentSearchDetail.selectedSuggestions = selectedSuggestions;
  currentSearchDetail.searchLabel = searchLabel;
  currentSearchDetail.startDate = moment(startDate);
  currentSearchDetail.endDate = moment(endDate);
  currentSearchDetail.documentType = selectedDocumentTypes;
  dispatch(setCurrentSearchtDetail(currentSearchDetail));
};

export const getTopicNotificationDates = () => {
  const urlStartTime = new URLSearchParams(window.location.search).get('startTime');
  const urlEndTime = new URLSearchParams(window.location.search).get('endTime');

  if (urlStartTime && urlEndTime) return { urlStartTime, urlEndTime };
};

export const getThemeXExportFileName = () => {
  const searchLabel = getState().Topic.searchLabel;
  const alteredLabel = searchLabel?.replace(/ /g, '-');
  return `themeX${alteredLabel?.length ? '-' + alteredLabel : ''}-companies`;
};

export const resetTopicUrl = () => {
  const globalSearchText = new URLSearchParams(window.location.search).get('searchText');
  if (getTopicNotificationDates() || globalSearchText) {
    setDateRangeToOneYear();
    history.push('/topic');
  }
};
